export default __webpack_public_path__ + "static/media/gallerySub2.db5e6b5a.png";